<template>
    <div>
        <div style="text-align: left">
            <div style="padding: 2px;">
                <el-button type="primary" plain size="mini" @click="addPermissionMethod()">新 增</el-button>
            </div>
        </div>
        <el-table
            ref="myElTable"
            background="true"
            :data="tableData"
            @row-click="tableTrClick"
            border style="width: 100%;">
            <el-table-column type="index" label="序号" fixed="left" width="50"/>
            <el-table-column prop="methodName" label="按钮名称" width="130">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.methodName"/>
                </template>
            </el-table-column>
            <el-table-column prop="methodScriptName" label="按钮事件名称" width="230">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.methodScriptName"/>
                </template>
            </el-table-column>
            <el-table-column prop="methodIndex" label="排序" width="60">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.methodIndex"/>
                </template>
            </el-table-column>
            <el-table-column prop="methodIcon" label="按钮样式" >
                <template slot-scope="scope">
                    <el-input v-model="scope.row.methodIcon"/>
                </template>
            </el-table-column>
            <el-table-column prop="methodDisable" label="激活状态" width="100">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.methodDisable"/>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button type="primary" v-if="scope.row.methodPid==''" size="mini" plain @click="savePermissionMethod(scope.row)">保存</el-button>
                    <el-button type="success" v-if="scope.row.methodPid" size="mini" plain @click="updatePermissionMethod(scope.row)">修改</el-button>
                    <el-button type="danger" v-if="scope.row.methodPid" size="mini" plain @click="deletePermissionMethod(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    import {appjs} from "@/utiljs/apputil";
    export default {
        props: {
            closeWindow: {
                type: Function
            },
            selectedPerData:{
                type: Object
            }
        },
        data() {
            return {
                otherHeight:210,
                tableData: []
            }
        },
        created() {
            this.loadTableData(1);
        },
        methods:{
            loadTableData(){
                let load = appjs.loading();
                let _self = this;
                let params = {permissionPid:this.selectedPerData.id};
                appjs.httpRequest('queryMethodByPermissionPid',params).then(
                    (data)=>{
                        if(data.retCode&&data.retCode!="ok"){
                            appjs.showErrorMsg(data.retMsg)
                        }else{
                            _self.tableData = data.dataList;
                            this.$refs.myElTable.bodyWrapper.scrollTop =0;
                        }
                        appjs.unloading(load);
                    }
                ).catch(
                (errmsg)=>{
                    appjs.showErrorMsg(errmsg)
                    appjs.unloading(load);
                });
            },
            deletePermissionMethod(rowdata){
                let _self = this;
                this.$confirm('确定删除?', '提示', {
                    confirmButtonText: '确 定',
                    cancelButtonText: '取 消',
                    type: 'warning'
                }).then(() => {
                    let load = appjs.loading('数据删除中');
                    appjs.httpRequest('deletePermissionMethod',{methodPid:rowdata.methodPid}).then(
                        (data)=>{
                            if(data.retCode&&data.retCode!="ok"){
                                appjs.unloading(load);
                                appjs.showErrorMsg(data.retMsg)
                            }else{
                                appjs.unloading(load);
                                appjs.showSuccessMsg(data.retMsg)
                                _self.loadTableData();
                            }
                        }
                    ).catch(
                    (errmsg)=>{
                        appjs.showErrorMsg(errmsg)
                        appjs.unloading(load);
                    });
                });
            },
            updatePermissionMethod(rowdata){
                let load = appjs.loading();
                appjs.httpRequest('updatePermissionMethod',rowdata).then(
                    (data)=>{
                        if(data.retCode&&data.retCode!="ok"){
                            appjs.unloading(load);
                            appjs.showErrorMsg(data.retMsg)
                        }else{
                            appjs.unloading(load);
                            appjs.showSuccessMsg(data.retMsg)
                        }
                    }
                ).catch(
                (errmsg)=>{
                    appjs.showErrorMsg(errmsg)
                    appjs.unloading(load);
                });
            },
            addPermissionMethod(){
                let methodData = {
                    permissionPid:this.selectedPerData.id,
                    methodPid:'',
                    methodName:'',
                    methodScriptName:'',
                    methodIndex:'',
                    methodIcon:'',
                    methodDisable:'1'
                }
                this.tableData.push(methodData)
            },
            savePermissionMethod(rowdata){
                let load = appjs.loading();
                appjs.httpRequest('savePermissionMethod',rowdata).then(
                    (data)=>{
                        if(data.retCode&&data.retCode!="ok"){
                            appjs.unloading(load);
                            appjs.showErrorMsg(data.retMsg)
                        }else{
                            appjs.unloading(load);
                            rowdata.methodPid = data.additionalData;
                            appjs.showSuccessMsg(data.retMsg)
                        }
                    }
                ).catch(
                    (errmsg)=>{
                        appjs.showErrorMsg(errmsg)
                        appjs.unloading(load);
                    });
            }
        }
    }
</script>
